/* eslint-disable */
import cytoscape from './cytoscape.min.js'
import edgehandles from './cytoscape-edgehandles.js';
import dagre from 'cytoscape-dagre'
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'
import { expect } from 'chai';
import { fromPairs, isUndefined } from 'lodash';

let palette = ["#80A8A8", "#909D9E", "#A88C8C", "#FF0D51", "#7A8C89", "#8C2318", "#5E8C6A", "#88A65E", "#BFB35A", "#F2C45A", "#1B676B", "#519548", "#88C425", "#BEF202", "#EAFDE6", "#FFF3DB", "#E7E4D5", "#D3C8B4", "#C84648", "#703E3B", "#594F4F", "#547980", "#45ADA8", "#9DE0AD", "#E5FCC2", "#FFE181", "#EEE9E5", "#FAD3B2", "#FFBA7F", "#FF9C97", "#655643", "#80BCA3", "#F6F7BD", "#E6AC27", "#BF4D28", "#4E395D", "#827085", "#8EBE94", "#CCFC8E", "#DC5B3E", "#300030", "#480048", "#601848", "#C04848", "#F07241", "#452E3C", "#FF3D5A", "#FFB969", "#EAF27E", "#3B8C88", "#2B222C", "#5E4352", "#965D62", "#C7956D", "#F2D974", "#F1396D", "#FD6081", "#F3FFEB", "#ACC95F", "#8F9924", "#F0D8A8", "#3D1C00", "#86B8B1", "#F2D694", "#FA2A00", "#FFAB07", "#E9D558", "#72AD75", "#0E8D94", "#434D53", "#280904", "#680E34", "#9A151A", "#C21B12", "#FC4B2A", "#E7EDEA", "#FFC52C", "#FB0C06", "#030D4F", "#CEECEF", "#360745", "#D61C59", "#E7D84B", "#EFEAC5", "#1B8798", "#FF4E50", "#FC913A", "#F9D423", "#EDE574", "#E1F5C4", "#FCFEF5", "#E9FFE1", "#CDCFB7", "#D6E6C3", "#FAFBE3", "#BCBDAC", "#CFBE27", "#F27435", "#F02475", "#3B2D38", "#CC0C39", "#E6781E", "#C8CF02", "#F8FCC1", "#1693A7", "#A8E6CE", "#DCEDC2", "#FFD3B5", "#FFAAA6", "#FF8C94", "#80A8A8", "#909D9E", "#A88C8C", "#FF0D51", "#7A8C89", "#EDEBE6", "#D6E1C7", "#94C7B6", "#403B33", "#D3643B", "#322938", "#89A194", "#CFC89A", "#CC883A", "#A14016", "#B1E6D1", "#77B1A9", "#3D7B80", "#270A33", "#451A3E", "#E7EDEA", "#FFC52C", "#FB0C06", "#030D4F", "#CEECEF", "#7E5686", "#A5AAD9", "#E8F9A2", "#F8A13F", "#BA3C3D", "#CC5D4C", "#FFFEC6", "#C7D1AF", "#96B49C", "#5B5847", "#807462", "#A69785", "#B8FAFF", "#E8FDFF", "#665C49", "#000000", "#9F111B", "#B11623", "#292C37", "#CCCCCC", "#F38A8A", "#55443D", "#A0CAB5", "#CDE9CA", "#F1EDD0", "#A32C28", "#1C090B", "#384030", "#7B8055", "#BCA875", "#A3C68C", "#879676", "#6E6662", "#4F364A", "#340735", "#CC0C39", "#E6781E", "#C8CF02", "#F8FCC1", "#1693A7", "#027B7F", "#FFA588", "#D62957", "#BF1E62", "#572E4F", "#FFB884", "#F5DF98", "#FFF8D4", "#C0D1C2", "#2E4347", "#B5AC01", "#ECBA09", "#E86E1C", "#D41E45", "#1B1521", "#6DA67A", "#99A66D", "#A9BD68", "#B5CC6A", "#C0DE5D", "#BED6C7", "#ADC0B4", "#8A7E66", "#A79B83", "#BBB2A1", "#73C8A9", "#DEE1B6", "#E1B866", "#BD5532", "#373B44", "#CCF390", "#E0E05A", "#F7C41F", "#FC930A", "#FF003D", "#379F7A", "#78AE62", "#BBB749", "#E0FBAC", "#1F1C0D", "#FBC599", "#CDBB93", "#9EAE8A", "#335650", "#F35F55", "#85847E", "#AB6A6E", "#F7345B", "#353130", "#CBCFB4", "#A70267", "#F10C49", "#FB6B41", "#F6D86B", "#339194", "#A70267", "#F10C49", "#FB6B41", "#F6D86B", "#339194", "#C7FCD7", "#D9D5A7", "#D9AB91", "#E6867A", "#ED4A6A", "#556270", "#4ECDC4", "#C7F464", "#FF6B6B", "#C44D58", "#2B222C", "#5E4352", "#965D62", "#C7956D", "#F2D974", "#311D39", "#67434F", "#9B8E7E", "#C3CCAF", "#A51A41", "#EC4401", "#CC9B25", "#13CD4A", "#7B6ED6", "#5E525C", "#1D1313", "#24B694", "#D22042", "#A3B808", "#30C4C9", "#11644D", "#A0B046", "#F2C94E", "#F78145", "#F24E4E", "#95A131", "#C8CD3B", "#F6F1DE", "#F5B9AE", "#EE0B5B", "#E4DED0", "#ABCCBD", "#7DBEB8", "#181619", "#E32F21", "#058789", "#503D2E", "#D54B1A", "#E3A72F", "#F0ECC9", "#5E9FA3", "#DCD1B4", "#FAB87F", "#F87E7B", "#B05574", "#FC354C", "#29221F", "#13747D", "#0ABFBC", "#FCF7C5", "#E0EFF1", "#7DB4B5", "#FFFFFF", "#680148", "#000000", "#B9D3B0", "#81BDA4", "#B28774", "#F88F79", "#F6AA93", "#322938", "#89A194", "#CFC89A", "#CC883A", "#A14016", "#805841", "#DCF7F3", "#FFFCDD", "#FFD8D8", "#F5A2A2", "#BCBDAC", "#CFBE27", "#F27435", "#F02475", "#3B2D38", "#395A4F", "#432330", "#853C43", "#F25C5E", "#FFA566", "#E8D5B7", "#0E2430", "#FC3A51", "#F5B349", "#E8D5B9", "#C1B398", "#605951", "#FBEEC2", "#61A6AB", "#ACCEC0", "#A69E80", "#E0BA9B", "#E7A97E", "#D28574", "#3B1922", "#C1B398", "#605951", "#FBEEC2", "#61A6AB", "#ACCEC0", "#4B3E4D", "#1E8C93", "#DBD8A2", "#C4AC30", "#D74F33", "#B6D8C0", "#C8D9BF", "#DADABD", "#ECDBBC", "#FEDCBA", "#ECD078", "#D95B43", "#C02942", "#542437", "#53777A", "#F06D61", "#DA825F", "#C4975C", "#A8AB7B", "#8CBF99", "#A3A948", "#EDB92E", "#F85931", "#CE1836", "#009989", "#6D9788", "#1E2528", "#7E1C13", "#BF0A0D", "#E6E1C2", "#413E4A", "#73626E", "#B38184", "#F0B49E", "#F7E4BE", "#1D1313", "#24B694", "#D22042", "#A3B808", "#30C4C9", "#B6D8C0", "#C8D9BF", "#DADABD", "#ECDBBC", "#FEDCBA", "#B5AC01", "#ECBA09", "#E86E1C", "#D41E45", "#1B1521", "#8DCCAD", "#988864", "#FEA6A2", "#F9D6AC", "#FFE9AF", "#E9E0D1", "#91A398", "#33605A", "#070001", "#68462B", "#3A111C", "#574951", "#83988E", "#BCDEA5", "#E6F9BC", "#1C2130", "#028F76", "#B3E099", "#FFEAAD", "#D14334", "#5E3929", "#CD8C52", "#B7D1A3", "#DEE8BE", "#FCF7D3", "#00A8C6", "#40C0CB", "#F9F2E7", "#AEE239", "#8FBE00", "#D1313D", "#E5625C", "#F9BF76", "#8EB2C5", "#615375", "#452632", "#91204D", "#E4844A", "#E8BF56", "#E2F7CE", "#8DCCAD", "#988864", "#FEA6A2", "#F9D6AC", "#FFE9AF", "#FFEFD3", "#FFFEE4", "#D0ECEA", "#9FD6D2", "#8B7A5E", "#FF003C", "#FF8A00", "#FABE28", "#88C100", "#00C176", "#2B2726", "#0A516D", "#018790", "#7DAD93", "#BACCA4", "#4E395D", "#827085", "#8EBE94", "#CCFC8E", "#DC5B3E", "#6DA67A", "#77B885", "#86C28B", "#859987", "#4A4857", "#5E412F", "#FCEBB6", "#78C0A8", "#F07818", "#F0A830", "#429398", "#6B5D4D", "#B0A18F", "#DFCDB4", "#FBEED3", "#95A131", "#C8CD3B", "#F6F1DE", "#F5B9AE", "#EE0B5B", "#E3DFBA", "#C8D6BF", "#93CCC6", "#6CBDB5", "#1A1F1E", "#B7CBBF", "#8C886F", "#F9A799", "#F4BFAD", "#F5DABD", "#CCF390", "#E0E05A", "#F7C41F", "#FC930A", "#FF003D", "#AB526B", "#BCA297", "#C5CEAE", "#F0E2A4", "#F4EBC3"];
let polygon_style = [
  {
    selector: 'node',
    style: {
      'content': function(el) { return el.data('label') + "\n#" + vg.depth[el.id()]; },
      'text-opacity': 1,
      'text-valign': 'center',
      'text-halign': 'center',
      'text-wrap': 'wrap',
      'text-outline-color': '#000000',
      'text-outline-width': 0.5,
      'border-color': '#000000',
      'border-width': 0.3,
      'background-color': function(el) { return palette[vg.depth[el.id()] % palette.length]; },
      'border-color': '#000000',
      'color': '#ffffff',
      'height': '46px',
      'width': '46px'
    }
  },
  {
    selector: 'edge',
    style: {
      'curve-style': 'bezier',
      'width': 4,
      'target-arrow-shape': 'triangle',
      'line-color': '#6e7173',
      'target-arrow-color': '#6e7173'
    }
  },
  {
    selector: '.click',
    style: {
      'border-width': 2,
      'border-color': '#36d1c9'
    },
  },
  {
    selector: '.cyclic',
    style: {
      'curve-style': 'bezier',
      'width': 4,
      'target-arrow-shape': 'triangle',
      'line-color': '#dc3545',
      'target-arrow-color': '#dc3545'
    }
  },

  // some style for the extension

  {
    selector: '.eh-handle',
    style: {
      'background-color': 'red',
      'width': 12,
      'height': 12,
      'opacity': 0,
      'shape': 'ellipse',
      'overlay-opacity': 0,
      'border-width': 12, // makes the handle easier to hit
      'border-opacity': 0
    }
  },

  {
    selector: '.eh-hover',
    style: {
      'background-color': 'red'
    }
  },

  {
    selector: '.eh-source',
    style: {
      'border-width': 2,
      'border-color': 'red'
    }
  },

  {
    selector: '.eh-target',
    style: {
      'border-width': 2,
      'border-color': 'red'
    }
  },

  {
    selector: '.eh-preview, .eh-ghost-edge',
    style: {
      'background-color': 'red',
      'line-color': 'red',
      'target-arrow-color': 'red',
      'source-arrow-color': 'red'
    }
  },

  {
    selector: '.eh-ghost-edge.eh-preview-active',
    style: {
      'opacity': 0
    }
  }
]

let day_style = [
  {
    selector: 'node',
    style: {
      'content': function(el) { return el.data('label') },
      'text-opacity': 1,
      'text-valign': 'center',
      'text-halign': 'center',
      'text-wrap': 'wrap',
      'text-outline-color': '#000000',
      'text-outline-width': 0.5,
      'border-color': '#000000',
      'border-width': 0.3,
      'background-color': function(el) { return palette[(vg.groups[el.id()] ? vg.groups[el.id()] : 0) % palette.length]; },
      'border-color': '#000000',
      'color': '#ffffff',
      'height': '46px',
      'width': '46px'
    }
  },
  {
    selector: 'edge',
    style: {
      'curve-style': 'bezier',
      'width': 4,
      'target-arrow-shape': 'triangle',
      'line-color': '#6e7173',
      'target-arrow-color': '#6e7173'
    }
  },
  {
    selector: '.cyclic',
    style: {
      'curve-style': 'bezier',
      'width': 4,
      'target-arrow-shape': 'triangle',
      'line-color': '#dc3545',
      'target-arrow-color': '#dc3545'
    }
  },

  // some style for the extension

  {
    selector: '.eh-handle',
    style: {
      'background-color': 'red',
      'width': 12,
      'height': 12,
      'opacity': 0,
      'shape': 'ellipse',
      'overlay-opacity': 0,
      'border-width': 12, // makes the handle easier to hit
      'border-opacity': 0
    }
  },

  {
    selector: '.eh-hover',
    style: {
      'background-color': 'red'
    }
  },

  {
    selector: '.eh-source',
    style: {
      'border-width': 2,
      'border-color': 'red'
    }
  },

  {
    selector: '.eh-target',
    style: {
      'border-width': 2,
      'border-color': 'red'
    }
  },

  {
    selector: '.eh-preview, .eh-ghost-edge',
    style: {
      'background-color': 'red',
      'line-color': 'red',
      'target-arrow-color': 'red',
      'source-arrow-color': 'red'
    }
  },

  {
    selector: '.eh-ghost-edge.eh-preview-active',
    style: {
      'opacity': 0
    }
  }
]

export default class ViseaGraph {
    canvas;
    cytoscape;
    dagre;
    tippy;
    depth = {};
    groups = {};
    _polygons;
    _dayspolygons;
    editing = false;
    changed = false;
    days = false;
    pushSequence = null;
    sequence = {};
    outHandler = null;
    lastClick = null;
    constructor(canvas, handler) {
        /* eslint-disable */
        this.edgeflag = false;
        this.canvas = document.getElementById(canvas);
        this.cytoscape = cytoscape;
        this.edgehandles = edgehandles
        this.dagre = dagre;
        this.tippy = tippy;
        try {
          this.cytoscape.use(this.dagre)
          this.cytoscape.use(this.edgehandles)
        }catch {

        }
        this.outHandler = handler;
        this.tippy_instance = this.tippy(this.canvas, {
            content: '',
            placement: 'right-start',
            trigger: 'manual',
            interactive: true,
            arrow: false,
            offset: [0, 0],
            allowHTML: true,
        });
        this.depth = {};
        this.groups = {};
        this.sequence = {};
        this._polygons = [];

    }

    importSession(graphData) {
      if(graphData === undefined) {
        return;
      }
      if(graphData.depth !== undefined) {
        this.depth = graphData.depth;
      }
      if(graphData.groups !== undefined) {
        this.groups = graphData.groups;
      }
      if(graphData.sequence !== undefined) {
        this.sequence = graphData.sequence;
      }else{
        this.sequence = {}
      }
    }

    exportSession() {
      return {
        depth: this.depth,
        groups: this.groups,
        sequence: this.sequence
      };
    }

    exportSequence () {
      const out = [];
      Object.keys(this.sequence).forEach(day => {
        if (out[this.sequence[day]] === undefined) {
          out[this.sequence[day]] = [];
        }

        out[this.sequence[day]].push(day);
      });

      if (out.length === 0) {
        out.push([]);
      }

      return new Array(out.length).fill([]).map((el, pos) => out[pos] || el);
    }

    setCanvas(canvas) {
      this.canvas = canvas;
      this.tippy_instance = this.tippy(this.canvas, {
        content: '',
        placement: 'right-start',
        trigger: 'manual',
        interactive: true,
        arrow: false,
        offset: [0, 0],
        allowHTML: true,
      });
    }
    saveDepth() {
      let target = document.getElementById(this.target + '_input');
      let value = target.value;
      this.depth[this.target] = Number.parseInt(value);
      let p = target.parentElement;
      p.removeChild(target);
      p.firstElementChild.innerHTML = value;
      this.editing = false;
      document.getElementById(this.target + '_save').style.display = 'none';
      this.loadPolygon(this._polygons);
      this.tippy_instance.hide();
      //this.cy.batch();
    }
    externalClick(id) {
      // console.log('external', );
      let target = window.vg.cy.getElementById(id);
      target.trigger('tap');
    }
    saveGroup() {
      let target = document.getElementById(this.target + '_input');
      let value = target.value;
      this.groups[this.target] = Number.parseInt(value);
      let p = target.parentElement;
      p.removeChild(target);
      p.firstElementChild.innerHTML = value;
      this.editing = false;
      document.getElementById(this.target + '_save').style.display = 'none';
      this.loadPolygon(this._dayspolygons, true);
      this.tippy_instance.hide();
      //this.cy.batch();
    }
    isCyclic() {
      let cyclic = false;
      let depth_map = {}
      let cycle_map = [];
      function dfs(node, traceback, depth, cycleMap) {
        if(depth_map[node.id()] === undefined) {
          depth_map[node.id()] = depth;
        }else{
          if(depth_map[node.id()] < depth) {
            depth_map[node.id()] = depth;
          }
        }
        if(!traceback.includes(node.id())) {
          let new_traceback = [...traceback];
          new_traceback.push(node.id());
          node.outgoers().forEach(edge => {
            if(edge.target().id() !== undefined) {
              dfs(edge.target(), new_traceback, depth + 1, cycleMap);
            }
          })
        }else{
          cyclic = true;
          let cycleTrack = {}
          cycleTrack.start = node.id();
          cycleTrack.stop = traceback[traceback.length - 1];
          cycleTrack.trace = traceback.slice(traceback.indexOf(node.id()));
          cycleMap.push(cycleTrack);
        }
      }
      if(this.cy.elements().roots().length < 1) {
        return true;
      }
      this.cy.elements().roots().forEach(root => {
        dfs(root, [], 0, cycle_map);
      })
      if(cyclic) {
        let done = []
        cycle_map.forEach(cyclePath => {
          if(done.filter(elem => elem.start === cyclePath.start && elem.stop === cyclePath.stop).length == 0){
            let cycleTarget = this.cy.getElementById(cyclePath.start)
            let cycleSource = this.cy.getElementById(cyclePath.stop);
            cycleSource.edgesTo(cycleTarget).forEach(edge => {
              edge.addClass('cyclic');
            });

            for(let i = 0; i < cyclePath.trace.length - 1; i++) {
              let source = this.cy.getElementById(cyclePath.trace[i]);
              let target = this.cy.getElementById(cyclePath.trace[i + 1])
              source.edgesTo(target).forEach(edge => {
                edge.addClass('cyclic');
              })
            }
          }
        })
      }
      return cyclic;
    }
    externalHandler(object) {
      if(!this.editing) {
        this.editing = true;
        let target = object.id
        this.target = target;
        let input = document.createElement('input')
        input.type = 'text';
        input.style = 'width: 48px';
        input.id = target + '_input';
        this.changed = false;
        document.getElementById(target + '_save').style.display = 'block';
        if(object.firstElementChild.innerHTML !== '') {
          input.value = object.firstElementChild.innerHTML;
          object.firstElementChild.innerHTML = '';
          object.appendChild(input);
        }
      }
    }

    destroy() {
      this.cy.destroy();
      // console.log("DESTROY:", this.cy.destroyed());
    }

    contextText() {
        return "True"
    }
    _polygon_to_elements(polygons) {
        let elements = {
          nodes: [],
          edges: []
        }
        polygons.forEach(polygon => {
          if(this.days) {
            if(this.groups[polygon.id] === undefined) {
              this.groups[polygon.id] = 0;
            }
          }else{
            if(this.depth[polygon.id] === undefined) {
              this.depth[polygon.id] = 0;
            }
          }
          elements.nodes.push({data: {  id: polygon.id,label: polygon.label}});
          polygon.parents.forEach(parent_polygon => {
            elements.edges.push({data: {
              source: parent_polygon,
              target: polygon.id
            }})
          })
        });
        return elements;
    }
    _called() {

    }
    detachEdge(parent, child) {
        this.tippy_instance.hide()
        let i = 0;
        let found = false;
        for(i = 0; i < this._polygons.length; i++)
            if(this._polygons[i].id == child){ found = true; break; }
        if(found){
            this._polygons[i].parents = this._polygons[i].parents.filter( item => item != parent)
        }
        this.loadPolygon(this._polygons)
    }
    attachNode(target) {
        this.cy.edgehandles().enable()
        this.cy.edgehandles().start(this.cy.$id(target))
    }

    exportAll() {
      this._polygons.forEach(polygon => {
        polygon.day = this.depth[polygon.id];
      })
      return this._polygons;
    }
    exportDaysGraph() {
      let days = {};
      this._polygons.forEach(polygon => {
        let polygon_day = polygon.day;
        if(!Object.keys(days).includes(polygon_day)) {
          days[polygon_day] = {};
          days[polygon_day].id = polygon_day;
          days[polygon_day].parents = [];
          days[polygon_day].label = polygon_day;
        }
        polygon.parents.forEach(parentPolygon => {
          if(!days[polygon_day].parents.includes(this.depth[parentPolygon]) && this.depth[parentPolygon] !== polygon_day) {
            days[polygon_day].parents.push(this.depth[parentPolygon])
          }
        })
      })
      let day_arr = []
      //console.log(days);
      Object.keys(days).forEach(day => day_arr.push(days[day]));
      return day_arr;
    }
    _genContent(target) {
        /* eslint-disable */
        if(!this.days) {
          return `<div class="d-flex flex-column">
                    <p onclick="window.vg.externalHandler(this)" id="${target}">Giornata: #<label>${this.depth[target]}</label></p>
                    <button class="btn-success" id="${target}_save" onclick="window.vg.saveDepth()" style="display: none; margin-left: auto; margin-right: auto; margin-bottom: 4px">Salva</button>
                    <button class="btn btn-primary" style="margin-left: auto; margin-right: auto; margin-bottom: 4px" onclick='window.vg.attachNode(\"${target}\")'>Aggancia Nodo</button>
                  </div>`
        }else {
          return `<div class="d-flex flex-column">
                    <p onclick="window.vg.externalHandler(this)" id="${target}">Gruppo: #<label>${this.groups[target]}</label></p>
                    <button class="btn-success" id="${target}_save" onclick="window.vg.saveGroup()" style="display: none; margin-left: auto; margin-right: auto; margin-bottom: 4px">Salva</button>
                    <button class="btn btn-primary" onclick='window.vg.pushSequence(\"${target}\")'>Aggiungi a Sequenza</button>
                  </div>`;
        }
    }
    dfs() {
      function dfs(node, traceback, depth, depthMap) {
        if(depthMap[node.id()] === undefined) {
          depthMap[node.id()] = depth;
        }else{
          if(depthMap[node.id()] < depth) {
            depthMap[node.id()] = depth;
          }
        }
        if(!traceback.includes(node.id())) {
          let new_traceback = [...traceback];
          new_traceback.push(node.id());
          node.outgoers().forEach(edge => {
            if(edge.target().id() !== undefined) {
              dfs(edge.target(), new_traceback, depth + 1, depthMap);
            }
          })
        }
      }
      if(this.cy.elements().roots().length < 1) {
        return true;
      }
      if(this.days) { this.groups = {} } else { this.depth = {} }
      this.cy.elements().roots().forEach(root => {
        dfs(root, [], 0,  this.days ? this.groups : this.depth);
      })
      this.loadPolygon(this.days ? this._dayspolygons : this._polygons, this.days);
    }

    updateSequence(seq) {
      this.sequence = {};
      for (let i = 0; i < seq.length; i++) {
        for(let j = 0; j < seq[i].length; j++) {
          this.sequence[seq[i][j]] = i;
        }
      }
    }

    loadPolygon(polygons, days=false) {
        if(polygons === undefined) {
          return;
        }
        this.days = days;
        if(this.days) {
          this._dayspolygons = polygons;
        }else{
          this._polygons = polygons
        }
        let elements = this._polygon_to_elements(polygons)
        if(this.days) {
          //console.log(elements);
        }
        this.cy = cytoscape({
            container: this.canvas,
            boxSelectionEnabled: false,
            autounselectify: true,
            layout: {
              name: 'dagre',
              avoidOverlap: true,

            },
            style: days ? day_style : polygon_style,
            elements: elements,
        });

        if(Object.keys(this.depth).length === 0){
          var dfs = this.cy.elements().dfs({
            roots: this.cy.elements().roots(),
            visit: (v, e, u, i, depth) => {
              if(this.depth[v.id()] > depth){}else{
                this.depth[v.id()] = depth;
              }
            },
            directed: true
          });
          var path = dfs.path;
          path.select();
        }


        this.cy.on('tap', 'node', (evt) => {
          if(!this.days){
            if(this.lastClick){
              this.lastClick.removeClass('click');

            }
            evt.target.addClass('click');
            // console.log('target:',evt.target)
            this.lastClick = evt.target;
            if(this.outHandler){
              let target = evt.target.data('id');
              let related = [];
              let day = this.depth[target];
              Object.keys(this.depth).forEach(polyId => {
                if(this.depth[polyId] == day && polyId !== target) {
                  related.push(polyId);
                }
              });
              this.outHandler(target, related, palette[1]);
            }
        }
        })
        this.cy.on('cxttap', 'node', (evt) => {
            evt.preventDefault();
            this.editing = false;
            this.tippy_instance.setProps({
                content: this._genContent(evt.target.id()),
                getReferenceClientRect: () => ({
                  width: 0,
                  height: 0,
                  top: evt.originalEvent.clientY,
                  bottom: evt.originalEvent.clientY,
                  left: evt.originalEvent.clientX,
                  right: evt.originalEvent.clientX,
                }),
              });
            if(this.edgeflag === false)
                this.tippy_instance.show();
            this.edgeflag = false;
       });
       this.cy.on('cxttap', 'edge', evt => {
        let source = evt.target.data('source')
        let target = evt.target.data('target')
        evt.preventDefault();
        /* eslint-disable */
        this.tippy_instance.setProps({
            content: `<button onclick='window.vg.detachEdge(\"${source}\", \"${target}\")'>Sgancia</button>`,
            getReferenceClientRect: () => ({
              width: 0,
              height: 0,
              top: evt.originalEvent.clientY,
              bottom: evt.originalEvent.clientY,
              left: evt.originalEvent.clientX,
              right: evt.originalEvent.clientX,
            }),
          });
        this.tippy_instance.show();
   });
    this.cy.on('ehstart', (event, sourceNode, targetNode, addedEles) => {
        this.edgeflag = true;
	    this.tippy_instance.hide()
    });
    this.cy.on('mouseup', evt => {
        //console.log(evt)
	    //this.tippy_instance.hide()
    });
    this.cy.on('ehcomplete', (event, sourceNode, targetNode, addedEles) => {
        let child = targetNode.data('id')
        let parent = sourceNode.data('id')
	      this.tippy_instance.hide()
        this.cy.fit()
        let polygons;
        if(this.days) {
          polygons = this._dayspolygons;
        }else{
          polygons = this._polygons;
        }

        let i = 0;
        let found = false;
        for(i = 0; i < polygons.length; i++)
            if(polygons[i].id == child){ found = true; break; }
        if(found){
          polygons[i].parents.push(Number.parseInt(parent));
        }
        this.loadPolygon(polygons, this.days)
    });
    }
}
